export default __webpack_public_path__ + "static/media/weezticket.65ec5551.svg";